import type { LayoutPaneReactElement } from '../Types/LayoutPaneReactElement'
import { LayoutPaneCategoryType } from '../Panes'
import { getPaneCategoryFromPaneType } from '../Panes/helpers/get-pane-category-from-pane-type'

export const mergeDelegatedPanesIntoLayoutChildren = (
    children: LayoutPaneReactElement[],
    delegatedPanes?: LayoutPaneReactElement[],
): LayoutPaneReactElement[] => {
    if (!delegatedPanes) return children

    const paneCategories: LayoutPaneCategoryType[] = delegatedPanes
        .map((pane) => getPaneCategoryFromPaneType(pane.props.paneType))
        .filter((c) => !!c) as LayoutPaneCategoryType[]

    const filteredChildren = children.filter((child) => {
        return !paneCategories.some((category) => category === getPaneCategoryFromPaneType(child.props.paneType))
    })

    return [...filteredChildren, ...delegatedPanes]
}
